import { Stack, useMediaQuery, useTheme } from '@mui/material';
import usersAPISlice from 'api/users/usersAPISlice';
import Loader from 'common/splash/Loader';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import BottomBar from './BottomBar/BottomBar';
import BaseDrawer from './drawer/BaseDrawer';

const PageFallback = () => <Loader inner testId='layout-loader' />;

const LayoutBase = () => {
  const { isLoading } = usersAPISlice.endpoints.getCurrentUser.useQuery();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));
  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      sx={{
        minHeight: '100vh, -webkit-fill-available',
        height: isMobile ? '100dvh' : 'auto',
        maxHeight: '100dvh',
      }}
    >
      {!isMobile ? <BaseDrawer /> : null}
      <Stack
        sx={{
          flex: 1,
          position: 'relative',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {isLoading ? (
          <PageFallback />
        ) : (
          <NuqsAdapter>
            <Suspense fallback={<PageFallback />}>
              <Outlet />
            </Suspense>
          </NuqsAdapter>
        )}
      </Stack>
      {isMobile ? <BottomBar /> : null}
    </Stack>
  );
};

export default LayoutBase;
